import { render } from "./ModalSalle.vue?vue&type=template&id=7c1852e6"
import script from "./ModalSalle.vue?vue&type=script&lang=js"
export * from "./ModalSalle.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__